import React from "react";

/**
 * @component StarOutlineIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <StarOutlineIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StarOutlineIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="StarOutlineIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12.706 2.103a1 1 0 01.454.455l2.63 5.329 5.881.854a1 1 0 01.554 1.706l-4.255 4.148 1.005 5.857a1 1 0 01-1.451 1.054l-5.26-2.765-5.26 2.765a1 1 0 01-1.451-1.054l1.004-5.857-4.255-4.148a1 1 0 01.554-1.706l5.881-.854 2.63-5.33a1 1 0 011.34-.454zm1.756 7.612L12.263 5.26l-2.198 4.455-4.916.713 3.557 3.469-.84 4.895 4.398-2.31 4.396 2.31-.839-4.895 3.557-3.468-4.916-.714z"
        fillRule="evenodd"
      />
    </svg>
  )
);
StarOutlineIcon.displayName = "StarOutlineIcon";
export default StarOutlineIcon;
